import React, { useEffect, useRef } from "react";
import { Link, useLocation } from "react-router-dom";
import { FooterHomeIcon } from "~misc/icons";
import { initialPath } from "~misc/paths";
import { FooterOptions } from "./FooterOptions";
import useFooter from "./hooks/useFooter";
import DefaultFooter from "./components/DefaultFooter";
import SimpliestFooter from "./components/SimpliestFooter";
import * as types from 'prop-types';

import "./style.scss";

const Footer = (props) => {
  const { variation } = props.options;

  const footerRef = useRef(null);

  const handleOrientationChange = () => {
    props.setFooterSpace(footerRef.current.children[0]?.offsetHeight);
  }

  useEffect(() => {
    handleOrientationChange();
  }, [footerRef])

  useEffect(() => {
    window.addEventListener("orientationchange", handleOrientationChange);
    return () => {
      window.removeEventListener("orientationchange", handleOrientationChange);
    };
  }, []);

  let component = (<DefaultFooter {...props} />);

  if (variation === "simpliest")
    component = (<SimpliestFooter {...props} />);

  return (
    <div ref={footerRef}>
      {component}
    </div>
  )
};

Footer.propTypes = {
  options: FooterOptions,
  setOptions: types.func
}

export default Footer;
